import React, { Component, Children } from 'react';
import { Layout, Card, Tag } from 'antd';
import styles from './layout.module.less';
import SearchBar from '@/components/SearchBar';
import GFooter from '@/components/GlobalFooter';
import operationTabList from './operation-tab-list';
import { withRouter } from '@souche-f2e/muji';

@withRouter
export default class DocLayout extends Component {
  onTabChange = key => {
    const { router } = this.props;
    switch (key) {
      case 'docking_process':
        router.push('/documents/docking_process');
        break;
      case 'docs':
        router.push('/documents/docs');
        break;
      case 'security_guard':
        router.push('/documents/security_guard');
        break;
      case 'common_tools': // 通用工具
        router.push('/documents/common_tools');
        break;
      default:
        break;
    }
  };

  render() {
    const { children, tabKey = 'docking_process' } = this.props;
    const cardOptions = {
      className: styles.tabsCard,
      // style: {{padding: '0'}},
      bordered: false,
      tabList: operationTabList,
      // activeTabKey: {location.pathname.replace(`${match.path}/`, '')},
      activeTabKey: tabKey,
      onTabChange: this.onTabChange
    };
    return (
      <Layout style={{ flexDirection: 'column' }}>
        {/* <Layout.Header className={styles.header}>
          <SearchBar></SearchBar>
        </Layout.Header> */}
        <Layout.Content className={styles.content} style={{ display: 'flex', flexDirection: 'column' }}>
          <Card {...cardOptions} style={{ flex: 1 }}>
            <div style={{ backgroundColor: '#f0f2f5', padding: '20px' }}>
              { children }
            </div>
          </Card>
        </Layout.Content>
        <Layout.Footer className={styles.footer}>
            <GFooter></GFooter>
        </Layout.Footer >
      </Layout>
    )
  }
}
